import { getUser } from "../services/Auth";
import api from "./api";

export const listarAreaCobertura = async () => {
  try {
    const usuario = await getUser();
    const id = usuario?.estabelecimento?._id;
    const area = await api.get(`/estabelecimentos/${id}/area-cobertura`);
    return area.data;
  } catch (error) {
    throw error;
  }
};

export const buscarAreaCobertura = async (data) => {
  try {
    const usuario = await getUser();
    const id = usuario?.estabelecimento?._id;
    const area = await api.get(
      `/estabelecimentos/${id}/area-cobertura/busca?area=${data}`,
    );
    return area.data;
  } catch (error) {
    throw error;
  }
};

export const criarAreaCobertura = async (data) => {
  try {
    const usuario = await getUser();
    const id = usuario?.estabelecimento?._id;
    const response = await api.post(`/estabelecimentos/${id}/area-cobertura`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeAreaCobertura = async (id_area) => {
  try {
    const usuario = await getUser();
    const id = usuario?.estabelecimento?._id;
    const response = await api.delete(
      `/estabelecimentos/${id}/area-cobertura/${id_area}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
